//It will return undefined or null if the token is not present or expired.
export type JwtTokenFn  = () =>Promise<string|undefined>
